export const environment = {
  production: false,
  envName: 'dev',
  redirectUri: '',
  backendUrl: 'https://app-api-genesis-selfservice-pipeline-eastus-dev-01.azurewebsites.net/ExtAPI/',
  scopeUri: '1c0807db-c338-4d1f-8ae5-800244c16599/user_impersonation',
  tenantId: '9ccd3796-bf60-4eb4-8f53-6b78ff39be60',
  clientId: '2e683edf-978e-49e6-9140-8254861b7dbd',
  authority: 'https://login.microsoftonline.com/9ccd3796-bf60-4eb4-8f53-6b78ff39be60/',
  flagsmithenvID: 'djATCSY5tvaWGq8GfzhF7A',
};
